export default "__VITE_ASSET__CIsEU6O9__"